import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import { bindActionCreators } from "redux";
import CarListing from "./component";
import { fetchConfig } from "../home/actions";
import { getPreApprovalLoanDetails, setPreApprovalCoachMarkDisplay } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";

import {
    fetchFilters,
    clearAllFilters,
    updateSelectedOnScreenFilter,
    updateAllFiltersVisibility,
    updateSortModalVisibility,
    fetchCategoryFilters,
    updateFilterOptionData
} from "../filters/actions";
import { reloadCarList, fetchClpData } from "./actions";

const mapStateToProps = ({
    filters: {
        categories,
        allFilters,
        selectedFilters,
        appliedFilters,
        urlOptions
    },
    carListing: {
        metaContent,
        dynamicContent,
        content,
        isSSR: isCarListSSR
    },
    location: {
        selectedCity
    },
    user: {
        secureToken,
        isUserZeroDpVariant,
        isLoggedIn,
        gaId
    },
    config: {
        saleConfig,
        ratingsConfig: {
            ratingAndReviews: {
                google: {
                    rating, reviews
                } = {}
            } = {}
        } = {}

    },
    preApprovalLoan: {
        showPreApprovalCoachmark
    },
    clpData: {
        faqData,
        browseSeoLinks
    },
    supportWidget: {
        showEmailSupportModal
    },
    abExperiment: {
        webPriceDropDesktop,
        webLocationHighlighting
    }
}) => ({
    isLoggedIn,
    metaContent,
    selectedCity,
    dynamicContent,
    categories,
    secureToken,
    saleConfig,
    showPreApprovalCoachmark,
    content,
    allFilters,
    selectedFilters,
    appliedFilters,
    isUserZeroDpVariant,
    urlOptions,
    isCarListSSR,
    faqData,
    browseSeoLinks,
    gaId,
    showEmailSupportModal,
    webPriceDropDesktop,
    webLocationHighlighting,
    rating,
    reviews
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchFiltersConnect: fetchFilters,
    fetchCategoryFiltersConnect: fetchCategoryFilters,
    clearAllFiltersConnect: clearAllFilters,
    getPreApprovalLoanDetailsConnect: getPreApprovalLoanDetails,
    updateSelectedOnScreenFilterConnect: updateSelectedOnScreenFilter,
    updateAllFiltersVisibilityConnect: updateAllFiltersVisibility,
    updateSortModalVisibilityConnect: updateSortModalVisibility,
    fetchConfigConnect: fetchConfig,
    setPreApprovalCoachMarkDisplayConnect: setPreApprovalCoachMarkDisplay,
    updateFilterOptionDataConnect: updateFilterOptionData,
    reloadCarListConnect: reloadCarList,
    fetchClpDataConnect: fetchClpData
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CarListing));
